module.exports = __webpack_public_path__ + "static/media/cardLast4NumbPast.31cd7b14.svg";